<div class="configuration-panel-container">
    <p-toast></p-toast>
    <p-confirmDialog #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog">
        <ng-template pTemplate="headless" let-message>
            <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
                <div class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
                    <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
                </div>
                <div class="mt-16 text-center w-full">
                    <h3 class="text-2xl font-bold text-gray-900 mb-3">
                        {{ message.header }}
                    </h3>
                    <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
                        {{ message.message }}
                    </p>
                    <div class="flex items-center justify-center gap-3 mt-6">
                        <button 
                            pButton 
                            type="button"
                            [label]="message.acceptLabel || 'Yes, Continue'" 
                            (click)="message.accept && message.accept()" 
                            [loading]="isGmailConnectLoading || isConnectLoading"
                            class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
                        </button>
                        <button 
                            pButton
                            type="button"
                            [label]="message.rejectLabel || 'Cancel'"
                            (click)="message.reject && message.reject()"
                            class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>

    <!-- Initial Loading State -->
    <div class="card bg-transparent" *ngIf="initialLoading">
        <div class="text-center py-8">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="2"></p-progressSpinner>
            <p class="mt-3 text-gray-600 text-lg">Loading configuration panel...</p>
        </div>
    </div>

    <div class="card" *ngIf="!initialLoading">
        <h2 class="text-3xl font-bold mb-4">Configuration Panel</h2>

        <p-tabView [(activeIndex)]="activeTab" styleClass="configuration-tabs">
            <!-- Notification Configuration Tab -->
            <p-tabPanel header="Notification Configuration">
                <div class="notification-config-content">
                    <!-- Info Note -->
                    <div class="info-note mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
                        <p class="text-sm text-blue-900">
                            <i class="pi pi-info-circle mr-2"></i>
                            <strong>Note:</strong> Connected emails will be used for sending internal notifications -
                            lead updates, reminders, follow-up reminders, profile credentials, and all system
                            notifications
                            to system users.
                        </p>
                    </div>

                    <!-- Sub Tabs for Email Management and Module Mapping -->
                    <p-tabView [(activeIndex)]="notificationTab" styleClass="notification-tabs">

                        <!-- Tab 1: Email Management -->
                        <p-tabPanel header="Email Management">
                            <div class="email-management-section py-4">

                                <!-- Authorized Domain Selection -->
                                <div class="field mb-4" *ngIf="authorizedDomains.length > 0">
                                    <label for="domain" class="block font-medium mb-2">
                                        Select Authorized Domain <span class="text-red-500">*</span>
                                    </label>
                                    <p-select id="domain" [options]="authorizedDomains" [(ngModel)]="selectedDomain"
                                        optionLabel="domain" placeholder="Select a domain" filterBy="domain"
                                        [showClear]="true" styleClass="w-full" (onChange)="onDomainChange()">
                                    </p-select>
                                </div>

                                <!-- No Domain Available -->
                                <div class="no-domain-section text-center py-5"
                                    *ngIf="authorizedDomains.length === 0 && !loadingDomains">
                                    <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
                                    <h4 class="text-xl font-semibold mb-2">No Authorized Domain Found</h4>
                                    <p class="text-gray-600 mb-4">
                                        Please connect at least one authorized domain to configure notification emails.
                                    </p>
                                    <p-button label="Connect Domain" icon="pi pi-link"
                                        (onClick)="navigateToDomainAuth()" styleClass="p-button-primary">
                                    </p-button>
                                </div>

                                <!-- Loading State -->
                                <div class="text-center py-5" *ngIf="loadingDomains">
                                    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="2">
                                    </p-progressSpinner>
                                    <p class="mt-3 text-gray-600">Loading domains...</p>
                                </div>

                                <!-- Add Email Section -->
                                <div class="add-email-section mt-4 mb-4" *ngIf="selectedDomain">
                                    <div class="field mb-3">
                                        <label class="block font-medium mb-2">Add Notification Emails</label>
                                        <div class="flex items-center gap-2 w-full">
                                            <!-- Email prefix input -->
                                            <input type="text" pInputText [(ngModel)]="newEmail"
                                                placeholder="Enter email prefix"
                                                (keyup.enter)="addNotificationEmailLocal()"
                                                class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500  focus:border-green-500 text-sm" />

                                            <!-- Domain addon -->
                                            <span
                                                class="px-3 py-2 rounded-lg border border-gray-300  bg-gray-100 text-gray-600 text-sm whitespace-nowrap">
                                                {{ '@' }}{{ selectedDomain?.domain }}

                                            </span>


                                            <!-- Add button -->
                                            <button pButton type="button" icon="pi pi-plus"
                                                (click)="addNotificationEmailLocal()" [disabled]="!newEmail" class="!rounded-lg !px-4 !py-2 
           bg-green-500 hover:bg-green-600 
           disabled:bg-gray-300 disabled:cursor-not-allowed
           transition-all duration-200">
                                            </button>
                                        </div>

                                    </div>
                                </div>

                                <!-- Debug Info (Always visible) -->
                                <!-- <div class="debug-info mb-3 mt-4" style="background: #f0f0f0; padding: 10px; border-radius: 4px;">
                                    <small>Debug: Total Emails = {{ allNotificationEmails.length }}</small>
                                </div> -->

                                <!-- Email List Table with Reputation Metrics -->
                                <div class="email-list-table mt-8" *ngIf="emailsWithMetrics.length > 0">

                                    <!-- Legend (hidden on mobile, shown on md and up) -->
                                    <div class="hidden md:flex items-center gap-4 mb-3 flex-wrap">
                                        <span class="text-sm font-semibold text-gray-600">Reputation Score:</span>
                                        <span class="flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-700">
                                            <i class="pi pi-circle-fill text-[8px]"></i> Excellent (≥ 80)
                                        </span>
                                        <span class="flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-700">
                                            <i class="pi pi-circle-fill text-[8px]"></i> Good (60–79)
                                        </span>
                                        <span class="flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-700">
                                            <i class="pi pi-circle-fill text-[8px]"></i> Needs Attention (&lt; 60)
                                        </span>
                                        <span class="flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">
                                            <i class="pi pi-circle-fill text-[8px]"></i> No Data Yet
                                        </span>
                                    </div>

                                    <!-- Mobile Legend (shown only on small screens) -->
                                    <div class="md:hidden mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                        <p class="text-xs font-bold text-blue-700 mb-2">Reputation Score Scale:</p>
                                        <div class="grid grid-cols-2 gap-2 text-xs">
                                            <div class="flex items-center gap-1">
                                                <span class="w-2 h-2 rounded-full bg-green-500"></span>
                                                <span class="text-gray-600">≥ 80</span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <span class="w-2 h-2 rounded-full bg-yellow-500"></span>
                                                <span class="text-gray-600">60–79</span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <span class="w-2 h-2 rounded-full bg-red-500"></span>
                                                <span class="text-gray-600">&lt; 60</span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <span class="w-2 h-2 rounded-full bg-gray-400"></span>
                                                <span class="text-gray-600">No Data</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Scrollable Table Wrapper -->
                                    <div class="overflow-x-auto rounded-lg border border-gray-200">
                                        <div style="min-width: 1000px;">
                                            <p-table [value]="emailsWithMetrics" styleClass="p-datatable-sm p-datatable-gridlines w-full"
                                                [rowHover]="true">
                                        <ng-template pTemplate="header">
                                            <tr class="text-xs uppercase tracking-wide text-gray-500">
                                                <th style="width:44px" class="text-center">#</th>
                                                <th>Email Address</th>
                                                <th style="width:120px" class="text-center">
                                                    <span pTooltip="Overall sender reputation score (0–100)" tooltipPosition="top">
                                                        Reputation Score
                                                    </span>
                                                </th>
                                                <th style="width:100px" class="text-center">
                                                    <span pTooltip="Total emails sent" tooltipPosition="top">Sent</span>
                                                </th>
                                                <th style="width:110px" class="text-center">
                                                    <span pTooltip="Open rate percentage" tooltipPosition="top">Open Rate</span>
                                                </th>
                                                <th style="width:110px" class="text-center">
                                                    <span pTooltip="Click rate percentage" tooltipPosition="top">Click Rate</span>
                                                </th>
                                                <th style="width:110px" class="text-center">
                                                    <span pTooltip="Bounce rate percentage" tooltipPosition="top">Bounce Rate</span>
                                                </th>
                                                <th style="width:110px" class="text-center">
                                                    <span pTooltip="Complaint rate percentage" tooltipPosition="top">Complaint</span>
                                                </th>
                                                <th style="width:100px" class="text-center">
                                                    <span pTooltip="Daily sending limit" tooltipPosition="top">Daily Limit</span>
                                                </th>
                                                <th style="width:70px" class="text-center">Actions</th>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                                            <tr [ngClass]="{'bg-blue-50': item._isPending}">

                                                <!-- # -->
                                                <td class="text-center text-gray-500 text-sm">{{ i + 1 }}</td>

                                                <!-- Email + status badges -->
                                                <td>
                                                    <div class="flex items-center gap-2">
                                                        <i class="pi pi-envelope text-blue-500 shrink-0"></i>
                                                        <span class="font-medium text-sm text-gray-800 break-all">{{ item.email }}</span>
                                                        <span *ngIf="item._isPending"
                                                            class="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-600 shrink-0">
                                                            Pending Save
                                                        </span>
                                                    </div>
                                                </td>

                                                <!-- Reputation Score -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.final_reputation_score"
                                                        class="inline-flex items-center justify-center gap-1 text-sm font-bold px-3 py-1 rounded-full border"
                                                        [ngClass]="getReputationScoreClass(item.reputation?.final_reputation_score)"
                                                        [class]="'border ' + getReputationScoreBorderClass(item.reputation?.final_reputation_score)">
                                                        {{ item.reputation.final_reputation_score }}
                                                    </span>
                                                    <span *ngIf="!item.reputation?.final_reputation_score"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Sent -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.sent !== undefined"
                                                        class="text-sm font-semibold text-gray-700">
                                                        {{ item.reputation?.sent ? item.reputation.sent : '---' }}
                                                    </span>
                                                    <span *ngIf="item.reputation?.sent === undefined"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Open Rate -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.open_rate !== undefined"
                                                        class="inline-block text-sm font-semibold"
                                                        [ngClass]="+item.reputation?.open_rate >= 30 ? 'text-green-600' : 'text-orange-500'">
                                                        {{ item.reputation?.open_rate ? item.reputation.open_rate + '%' : '---' }}
                                                    </span>
                                                    <span *ngIf="item.reputation?.open_rate === undefined"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Click Rate -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.click_rate !== undefined"
                                                        class="text-sm font-semibold text-indigo-600">
                                                        {{ item.reputation?.click_rate ? item.reputation.click_rate + '%' : '---' }}
                                                    </span>
                                                    <span *ngIf="item.reputation?.click_rate === undefined"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Bounce Rate -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.bounce_rate !== undefined"
                                                        class="inline-block text-sm font-semibold"
                                                        [ngClass]="+item.reputation?.bounce_rate > 2 ? 'text-red-600' : 'text-green-600'">
                                                        {{ item.reputation?.bounce_rate ? item.reputation.bounce_rate + '%' : '---' }}
                                                    </span>
                                                    <span *ngIf="item.reputation?.bounce_rate === undefined"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Complaint Rate -->
                                                <td class="text-center">
                                                    <span *ngIf="item.reputation?.complaint_rate !== undefined"
                                                        class="inline-block text-sm font-semibold"
                                                        [ngClass]="+item.reputation?.complaint_rate > 0.1 ? 'text-red-600' : 'text-green-600'">
                                                        {{ item.reputation?.complaint_rate ? item.reputation.complaint_rate + '%' : '---' }}
                                                    </span>
                                                    <span *ngIf="item.reputation?.complaint_rate === undefined"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Daily Limit -->
                                                <td class="text-center">
                                                    <span *ngIf="item.daily_limit !== undefined && item.daily_limit !== null"
                                                        class="inline-flex items-center gap-1 text-sm font-semibold text-purple-700 bg-purple-50 px-2 py-0.5 rounded-full">
                                                        <i class="pi pi-send text-xs"></i>
                                                        {{ item.daily_limit | number }}
                                                    </span>
                                                    <span *ngIf="item.daily_limit === undefined || item.daily_limit === null"
                                                        class="text-xs text-gray-400 italic">—</span>
                                                </td>

                                                <!-- Actions -->
                                                <td class="text-center">
                                                    <button pButton type="button" icon="pi pi-trash"
                                                        class="p-button-rounded p-button-text p-button-danger"
                                                        (click)="deleteNotificationEmailLocal(i)"
                                                        pTooltip="Remove email" tooltipPosition="top">
                                                    </button>
                                                </td>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="10" class="text-center py-6 text-gray-400">
                                                    <i class="pi pi-inbox text-3xl mb-2 block"></i>
                                                    No emails added yet
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                        </div>
                                    </div>
                                </div>

                                <!-- Save Button (Always visible when there are emails) -->
                                <div class="flex justify-end mt-4" *ngIf="emailsWithMetrics.length > 0">
                                    <p-button label="Save Configuration" icon="pi pi-save" [loading]="savingEmails"
                                        (onClick)="saveEmailConfiguration()">
                                    </p-button>
                                </div>
                            </div>
                        </p-tabPanel>

                        <!-- Tab 2: Module Email Mapping -->
                        <p-tabPanel header="Module Email Mapping">
                            <div class="module-mapping-section py-4">

                                <div *ngIf="allNotificationEmails.length === 0" class="text-center py-5">
                                    <i class="pi pi-inbox text-5xl text-gray-400 mb-3"></i>
                                    <p class="text-gray-600">Please add notification emails first to map them with
                                        modules.</p>
                                </div>

                                <div *ngIf="allNotificationEmails.length > 0">
                                    <p class="text-gray-600 mb-4">
                                        Assign which email should be used for notifications in each module.
                                    </p>

                                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                        <div *ngFor="let module of modules"
                                            class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm hover:shadow-md transition">
                                            <!-- Module name -->
                                            <label [for]="'module-' + module.key"
                                                class="block text-sm font-semibold text-gray-700 mb-2">
                                                {{ module.name }}
                                            </label>

                                            <!-- Email selector -->
                                            <p-select [id]="'module-' + module.key" [options]="allNotificationEmails"
                                                [(ngModel)]="module.assignedEmail"
                                                placeholder="Select notification email" [showClear]="true"
                                                styleClass="w-full" class="rounded-lg">
                                            </p-select>

                                            <!-- Optional helper text -->
                                            <p class="mt-2 text-xs text-gray-500">
                                                {{ module.description }}
                                            </p>
                                        </div>
                                    </div>


                                    <div class="flex justify-end mt-4">
                                        <p-button label="Save Configuration" icon="pi pi-save" [loading]="savingEmails"
                                            (onClick)="saveEmailConfiguration()">
                                        </p-button>
                                    </div>
                                </div>
                            </div>
                        </p-tabPanel>

                    </p-tabView>
                </div>
            </p-tabPanel>

            <!-- Communication Configuration Tab -->
            <p-tabPanel header="Communication Configuration">
                <div class="communication-config-content relative">
                    
                    <!-- Transparent Loading Overlay -->
                    <div *ngIf="isGmailTransparentLoading || isOutlookTransparentLoading" 
                         class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                        <div class=" flex flex-col items-center">
                            <p-progressSpinner styleClass="w-2 h-2" strokeWidth="2"></p-progressSpinner>
                        </div>
                    </div>
                    
                    <!-- Info Note -->
                    <div class="info-note mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
                        <p class="text-sm text-blue-900">
                            <i class="pi pi-info-circle mr-2"></i>
                            <strong>Note:</strong> Connect your email service provider to enable email communication
                            features throughout the application.
                        </p>
                    </div>

                    <p-tabView [(activeIndex)]="communicationTab" styleClass="communication-tabs">
                        <!-- Outlook Tab -->
                        <p-tabPanel header="Connect Outlook">
                            <div class="outlook-section py-4">
                                <!-- Not Connected State -->
                                <div class="text-center" *ngIf="outlookStatus === 'not_connected'">
                                    <i class="pi pi-microsoft text-6xl text-blue-600 mb-3"></i>
                                    <h3 class="text-xl font-semibold mb-2">Microsoft Outlook</h3>
                                    <p class="text-gray-600 mb-4">
                                        Connect your Microsoft Outlook account to send emails from the system.
                                    </p>
                                    <p-button label="Connect Outlook" [loading]="isConnectLoading"
                                        [disabled]="isConnectLoading" icon="pi pi-link" (onClick)="connectOutlook()"
                                        styleClass="p-button-lg p-button-primary">
                                    </p-button>
                                </div>

                                <!-- Expired State -->
                                <div class="text-center" *ngIf="outlookStatus === 'expired'">
                                    <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
                                    <h3 class="text-xl font-semibold mb-2">Connection Expired</h3>
                                    <p class="text-gray-700 mb-2">
                                        Your Outlook connection for <strong>{{ connectedOutlookEmail }}</strong> has
                                        expired.
                                    </p>
                                    <p class="text-orange-600 mb-4">
                                        Please connect again to refresh your token.
                                    </p>
                                    <p-button label="Reconnect Outlook" [loading]="isConnectLoading"
                                        [disabled]="isConnectLoading" icon="pi pi-refresh" (onClick)="connectOutlook()"
                                        styleClass="p-button-lg p-button-warning">
                                    </p-button>
                                </div>

                                <!-- Connected State -->
                                <div class="connected-state" *ngIf="outlookStatus === 'connected'">
                                    <div class="flex flex-column md:flex-row align-items-start md:align-items-center 
         justify-between gap-4 p-4 
         bg-green-50 border-1 border-green-200 border-round-xl 
         shadow-2 hover:shadow-4 transition-all duration-200">

                                        <!-- Left: Status + Email -->
                                        <div class="flex items-center gap-3">
                                            <div class="flex align-items-center justify-content-center w-3rem h-3rem border-circle ">
                                                <i class="pi pi-check-circle text-2xl text-green-600"></i>
                                            </div>

                                            <div>
                                                <div class="flex align-items-center gap-2 mb-1">
                                                    <h4 class="text-lg font-semibold m-0">Outlook Connected</h4>
                                                    <span class="text-xs font-medium px-2 py-1 
                 bg-green-100 text-green-700 border-round-full">
                                                        Active
                                                    </span>
                                                </div>

                                                <p class="text-sm text-gray-700 m-0">
                                                    {{ connectedOutlookEmail }}
                                                </p>

                                                <p class="text-xs text-gray-500 mt-1">
                                                    Emails will be sent using this account
                                                </p>
                                            </div>
                                        </div>

                                        <!-- Right: Actions -->
                                        <div class="flex items-center gap-2">
                                            <p-button icon="pi pi-times" label="Revoke Access" [loading]="revokeLoading"
                                                (onClick)="revokeOutlookAccess()"
                                                styleClass="p-button-danger p-button-outlined p-button-sm"
                                                pTooltip="Disconnect Outlook account" tooltipPosition="top">
                                            </p-button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </p-tabPanel>

                        <!-- Gmail Tab -->
                        <p-tabPanel header="Connect Gmail">
                            <div class="gmail-section py-4">
                                <!-- Not Connected State -->
                                <div class="text-center" *ngIf="gmailStatus === 'not_connected'">
                                    <i class="pi pi-google text-6xl text-red-600 mb-3"></i>
                                    <h3 class="text-xl font-semibold mb-2">Google Gmail</h3>
                                    <p class="text-gray-600 mb-4">
                                        Connect your Gmail account to send emails from the system.
                                    </p>
                                    <p-button label="Connect Gmail" [loading]="isGmailConnectLoading"
                                        [disabled]="isGmailConnectLoading" icon="pi pi-link" (onClick)="connectGmail()"
                                        styleClass="p-button-lg p-button-danger">
                                    </p-button>
                                </div>

                                <!-- Expired State -->
                                <div class="text-center" *ngIf="gmailStatus === 'expired'">
                                    <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
                                    <h3 class="text-xl font-semibold mb-2">Connection Expired</h3>
                                    <p class="text-gray-700 mb-2">
                                        Your Gmail connection for <strong>{{ connectedGmailEmail }}</strong> has
                                        expired.
                                    </p>
                                    <p class="text-orange-600 mb-4">
                                        Please connect again to refresh your token.
                                    </p>
                                    <p-button label="Reconnect Gmail" [loading]="isGmailConnectLoading"
                                        [disabled]="isGmailConnectLoading" icon="pi pi-refresh" (onClick)="connectGmail()"
                                        styleClass="p-button-lg p-button-warning">
                                    </p-button>
                                </div>

                                <!-- Connected State -->
                                <div class="connected-state" *ngIf="gmailStatus === 'connected'">
                                    <div class="flex flex-column md:flex-row align-items-start md:align-items-center 
         justify-between gap-4 p-4 
         bg-green-50 border-1 border-green-200 border-round-xl 
         shadow-2 hover:shadow-4 transition-all duration-200">

                                        <!-- Left: Status + Email -->
                                        <div class="flex items-center gap-3">
                                            <div class="flex align-items-center justify-content-center w-3rem h-3rem border-circle ">
                                                <i class="pi pi-check-circle text-2xl text-green-600"></i>
                                            </div>

                                            <div>
                                                <div class="flex align-items-center gap-2 mb-1">
                                                    <h4 class="text-lg font-semibold m-0">Gmail Connected</h4>
                                                    <span class="text-xs font-medium px-2 py-1 
                 bg-green-100 text-green-700 border-round-full">
                                                        Active
                                                    </span>
                                                </div>

                                                <p class="text-sm text-gray-700 m-0">
                                                    {{ connectedGmailEmail }}
                                                </p>

                                                <p class="text-xs text-gray-500 mt-1">
                                                    Emails will be sent using this account
                                                </p>
                                            </div>
                                        </div>

                                        <!-- Right: Actions -->
                                        <div class="flex items-center gap-2">
                                            <p-button icon="pi pi-times" label="Revoke Access" [loading]="gmailRevokeLoading"
                                                (onClick)="revokeGmailAccess()"
                                                styleClass="p-button-danger p-button-outlined p-button-sm"
                                                pTooltip="Disconnect Gmail account" tooltipPosition="top">
                                            </p-button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </p-tabPanel>

            <!-- WhatsApp Configuration Tab -->
            <p-tabPanel header="WhatsApp Configuration">
                <div class="whatsapp-config-content">
                    <!-- Info Note -->
                    <div class="info-note mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded">
                        <p class="text-sm text-blue-900">
                            <i class="pi pi-info-circle mr-2"></i>
                            <strong>Note:</strong> Configure Gupshup API credentials to enable WhatsApp messaging
                            capabilities throughout the application.
                        </p>
                    </div>

                    <div class="py-4">
                        <h3 class="text-xl font-semibold mb-4">Gupshup Configuration</h3>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                            <!-- Email -->
                            <div>
                                <label for="whatsappEmail" class="block font-medium mb-2">
                                    Email <span class="text-red-500">*</span>
                                </label>
                                <input id="whatsappEmail" type="email" [(ngModel)]="whatsappConfig.email"
                                    placeholder="Enter email address"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- API Key -->
                            <div>
                                <label for="apiKey" class="block font-medium mb-2">
                                    API Key <span class="text-red-500">*</span>
                                </label>
                                <input id="apiKey" type="text" [(ngModel)]="whatsappConfig.api_key"
                                    placeholder="Enter Gupshup API Key"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- App Name -->
                            <div>
                                <label for="appName" class="block font-medium mb-2">
                                    App Name <span class="text-red-500">*</span>
                                </label>
                                <input id="appName" type="text" [(ngModel)]="whatsappConfig.app_name"
                                    placeholder="Enter App Name"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- Source -->
                            <div>
                                <label for="source" class="block font-medium mb-2">
                                    Source <span class="text-red-500">*</span>
                                </label>
                                <input id="source" type="text" [(ngModel)]="whatsappConfig.source"
                                    placeholder="Enter Source"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- App ID -->
                            <div>
                                <label for="appId" class="block font-medium mb-2">
                                    App ID
                                </label>
                                <input id="appId" type="text" [(ngModel)]="whatsappConfig.app_id"
                                    placeholder="Enter App ID"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- Password -->
                            <div>
                                <label for="password" class="block font-medium mb-2">
                                    Password
                                </label>
                                <input id="password" type="password" [(ngModel)]="whatsappConfig.password"
                                    placeholder="Enter Password"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                            <!-- App Token -->
                            <div>
                                <label for="appToken" class="block font-medium mb-2">
                                    App Token
                                </label>
                                <input id="appToken" type="text" [(ngModel)]="whatsappConfig.app_token"
                                    placeholder="Enter App Token"
                                    class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            </div>

                        </div>

                        <!-- Actions -->
                        <div class="flex justify-end gap-3 mt-6">

                            <!-- save button -->
                            <p-button label="Save Configuration" icon="pi pi-save" [loading]="savingWhatsApp"
                                (onClick)="saveWhatsAppConfiguration()">
                            </p-button>
                        </div>
                    </div>

                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>